var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.254 51.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#702180;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product_Name_Generator",
    "data-name": "Product Name Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.627,
    cy: 25.627,
    r: 25.627
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.753,34.17H17.939a2.564,2.564,0,0,1-2.563-2.563v-9.4a2.563,2.563,0,0,1,2.563-2.562h3.417v-.855a2.562,2.562,0,0,1,2.563-2.562h5.125a2.562,2.562,0,0,1,2.563,2.562v.855h3.417a2.563,2.563,0,0,1,2.563,2.562v9.4a2.564,2.564,0,0,1-2.563,2.563Zm4.271-1.709a.854.854,0,0,0,.854-.854v-9.4a.854.854,0,0,0-.854-.854H31.607v11.1Zm-5.126,0v-11.1H23.064v11.1ZM17.085,22.21v9.4a.854.854,0,0,0,.854.854h3.417v-11.1H17.939A.854.854,0,0,0,17.085,22.21ZM29.9,19.648v-.855a.854.854,0,0,0-.854-.854H23.919a.855.855,0,0,0-.855.854v.855Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.cd315cfad50830b19b7bad95cac0ef41.svg";
export { ForwardRef as ReactComponent };